// src/hooks/useNextCode.js

import { useState, useEffect, useCallback } from 'react';
// IMPORTANTE: Adicionando as funções modulares do Firebase v9 para consulta
import { collection, query, orderBy, limit, getDocs } from "firebase/firestore"; 
import { db } from '../firebaseConfig'; // Importa a instância v9 do Firestore (correto!)

/**
 * Hook para buscar o próximo valor sequencial numérico para um campo específico em uma coleção.
 * @param {string} collectionPath - O caminho da coleção (ex: 'parameters/data/modelos').
 * @param {string} fieldName - O nome do campo a ser usado como código sequencial (ex: 'code').
 */
const useNextCode = (collectionPath, fieldName = 'code') => {
    const [nextCode, setNextCode] = useState(null);
    const [codeLoading, setCodeLoading] = useState(true);
    const [codeError, setCodeError] = useState('');

    // Função de busca principal, encapsulada em useCallback
    const fetchNextCode = useCallback(async () => {
        setCodeLoading(true);
        setCodeError('');
        
        // Verificação de segurança simplificada
        if (!db) {
            setCodeError("Objeto do Firestore não está inicializado.");
            setCodeLoading(false);
            setNextCode(null);
            return;
        }

        try {
            // 1. Cria a referência da coleção
            const modelsRef = collection(db, collectionPath);

            // 2. Cria a consulta v9: ordena pelo campo 'code' de forma decrescente e limita a 1
            const q = query(
                modelsRef, 
                orderBy(fieldName, 'desc'), 
                limit(1)
            );

            // 3. Executa a consulta v9
            const snapshot = await getDocs(q); 
            
            let maxCode = 0;

            if (!snapshot.empty) {
                const lastDoc = snapshot.docs[0].data();
                // Garante que o código seja tratado como número
                maxCode = Number(lastDoc[fieldName]) || 0; 
            }

            // 4. Define o próximo código (incrementa)
            setNextCode(maxCode + 1);

        } catch (err) {
            console.error("Erro ao buscar próximo código sequencial:", err);
            setCodeError("Falha ao gerar novo código sequencial. Detalhes: " + err.message);
            setNextCode(null);
        } finally {
            setCodeLoading(false);
        }
    }, [collectionPath, fieldName]); 

    useEffect(() => {
        fetchNextCode();
    }, [fetchNextCode]); 

    // refetchCode apenas executa a função de busca
    const refetchCode = () => {
        fetchNextCode();
    }

    return { nextCode, codeLoading, codeError, refetchCode };
};

export default useNextCode;